export default {
  toolBar: {
    preview: {
      title: 'Preview',
      tipsContext:
        'If there is no automatic redirect to the preview page, please click the',
      tipsLink: 'link',
      full: 'Preview from the beginning',
      beginWith: 'Preview from the current scene',
      disabledTip:
        'This project has nodes without videos, please adjust and try again.',
    },
    save: {
      title: 'Save',
      success: 'Saved Successfully',
      error: 'Save Failed',
    },
    projectName: 'Project Info',
    download: 'Download',
    preparing: 'preparing...',
    saveActionError: 'save action error',
    repeated:
      'The current project has been opened in the current browser for editing. Only one editing page is allowed to be opened for the same project.',
  },
  previewAction: {
    original: 'Original sound',
    mute: 'Mute',
  },
  navbarMiddle: {
    newGroup: {
      tips: 'Group (Ctrl/Command + G)',
    },
    unGroup: {
      tips: 'Ungroup (Ctrl/Command + Shift + G)',
    },
    copy: {
      tips: 'Copy (Ctrl/Command + C)',
      record: 'Recorded to copy panel',
    },
    move: {
      title: 'Layer order',
      moveToTop: 'Put on top',
      moveToBottom: 'Put on the bottom',
      moveUp: 'Move up one layer',
      moveDown: 'Move down one layer',
    },
    paste: {
      success: 'Paste',
      title: 'Paste',
      justPasteTheLayerEvent: 'Paste layer events only',
      justPasteTheLayerAppearance: 'Paste layer format only',
      justPastePositionAndSize:
        'Only paste the alignment and size of the layer',
      justPasteTheLayerAnimation: 'Paste the layer animation only',
      pasteLayer: 'Paste layer(Ctrl/Command + V)',
    },
    redo: {
      title: 'Redo',
    },
    undo: {
      title: 'Undo',
    },
  },
  recoverySound: 'Recovery Sound',
  languageSelector: {
    placeholder: 'Please select',
    label: 'Preview language',
  },
}
